import { requestService as api } from "../Request.service"  

const API_URL = {
  API_MANAGE: `/ERP/master-process/manage.php`,
};



const MasterProcessService = () => { 
 
  const update = (parm = {}) => api.put(`${API_URL.API_MANAGE}`, parm);
  const get = (fg_code, mp_id = null) =>
    api.get(
      `${API_URL.API_MANAGE}?fg_code=${fg_code}${mp_id ? `&mp_id=${mp_id}` : ""}`,
    );
  
  return {
    update,
    get,
  };
};

export default MasterProcessService;
